import { useLayoutEffect, useState } from 'react'

export function useIsClamped(ref) {
  const [isClamped, setIsClamped] = useState(false)

  useLayoutEffect(() => {
    const el = ref.current
    if (!el) return

    const update = () => setIsClamped(isLineClamped(el))
    update()

    const ro = new ResizeObserver(update)
    ro.observe(el)

    window.addEventListener('resize', update)
    return () => {
      ro.disconnect()
      window.removeEventListener('resize', update)
    }
  }, [ref])

  return isClamped
}

export function isLineClamped(el) {
  if (!el) return false

  const clampedHeight = el.getBoundingClientRect().height
  const { width } = el.getBoundingClientRect()

  const clone = el.cloneNode(true)

  // Match width for identical wrapping
  clone.style.width = `${width}px`

  // Remove clamping / constraints
  clone.style.webkitLineClamp = 'unset'
  clone.style.display = 'block'
  clone.style.overflow = 'visible'
  clone.style.maxHeight = 'none'
  clone.style.webkitBoxOrient = 'unset'

  // Keep out of layout/visibility
  clone.style.position = 'absolute'
  clone.style.visibility = 'hidden'
  clone.style.pointerEvents = 'none'
  clone.style.zIndex = '-1'

  el.parentElement?.appendChild(clone)

  // Choose the larger of scrollHeight / layout height
  const naturalHeight = Math.max(clone.scrollHeight, clone.getBoundingClientRect().height)

  clone.remove()

  return naturalHeight - clampedHeight > 1 // tolerance
}
